export default __webpack_public_path__ + "static/media/video_poster.e03ff41e.png";